module.exports = __webpack_public_path__ + "img/rotate_hint.e663ffb3.gif";